import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const QUOTATION_TO_INVOICE = "QUOTATION_TO_INVOICE";
export const QUOTATION_TO_INVOICE_LOADING =
"QUOTATION_TO_INVOICE_LOADING";
export const QUOTATION_TO_INVOICE_LOADING_FAILED =
"QUOTATION_TO_INVOICE_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const convertInovoiceTOQuotationLoading = ms => ({
    type: QUOTATION_TO_INVOICE_LOADING,
    payload: ms
    });
    
    export const convertInovoiceTOQuotationLoadingFailed = ms => ({
    type: QUOTATION_TO_INVOICE_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function convertInovoiceTOQuotation(obj) {
    const request = axios.post(
    `${process.env.REACT_APP_FILE}/accountRoutes/api/v1/caseQuotations/convertQuotationToInvoice`,obj,
    {
      headers: { 'Authorization': 'bearer ' +localStorage.accountantToken}
    });
    return dispatch => {

    dispatch(convertInovoiceTOQuotationLoading());
    request
    .then(response => {   
      console.log(response,"response")   
    if (response.status == 200) {
     console.log(response,"response convertInovoiceTOQuotation")
    dispatch({
    type: QUOTATION_TO_INVOICE,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        convertInovoiceTOQuotationLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(convertInovoiceTOQuotationLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(convertInovoiceTOQuotationLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(convertInovoiceTOQuotationLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


